import React from 'react'
import Link, { ILinkProps } from './Link'
import MobileButtonLink from './MobileButtonLink'

interface SmartLinkProps extends Omit<ILinkProps, 'exact'> {
  to?: string
  disabled?: boolean
  exact?: boolean
  children: React.ReactNode
  className?: string
  activeClassName?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>
}

export const SmartLink: React.FC<SmartLinkProps> = ({ to, disabled, children, className, onClick,onMouseEnter, ...rest }) => {
  if (!to || disabled) {
    return (
      <MobileButtonLink
        {...rest}
        className={className}
        onClick={e => {
          onClick(e)
        }}
        onMouseEnter={onMouseEnter ? onMouseEnter : undefined}
      >
        {children}
      </MobileButtonLink>
    )
  }

  return (
    <Link
      {...rest}
      to={to}
      className={className}
      onClick={e => onClick?.(e)}
    >
      {children}
    </Link>
  )
}

export default SmartLink
